import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  updateComplianceType,
  updateToggleListingSelection,
} from "@/reducers/clientcandidatedetail";

/**
 * A function that renders the ComplianceType component with a list of compliance types.
 *
 * @return {JSX.Element} The ComplianceType component
 */
const ComplianceType = () => {
  const { isLoading, activeComplianceTab, toggleListingSelection } =
    useSelector((state) => state.clientCandidateDetail);
  const dispatch = useDispatch();
  const data = [
    {
      name: "Core",
      type: "core",
    },
    {
      name: "Non-Core",
      type: "non_core",
    },
    {
      name: "Internal",
      type: "internal",
    },
    {
      name: "Enhanced",
      type: "client_enhance_compliance",
    },
  ];
  return (
    <div className="ComplianceType_Wrapper">
      <div className="flex flex-wrap gap-3">
        {data.map((item, index) => {
          return (
            <div
              className={`${
                isLoading ? "pointer-events-none" : ""
              } shiftperiod_item flex h-[40px] min-w-[99px] cursor-pointer select-none items-center justify-center rounded-lg p-3 text-base font-medium transition-all duration-200 ease-linear ${
                activeComplianceTab === item.type
                  ? "bg-lightblue text-primary"
                  : "bg-grey text-txtColor"
              }`}
              onClick={() => {
                dispatch(updateToggleListingSelection(!toggleListingSelection));
                dispatch(updateComplianceType(item.type));
              }}
              key={index}
            >
              {item.name}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ComplianceType;
